export default [{
    path: "realtimeAlarm",
    name: "realtimeAlarm",
    component: () =>
      import ("@/views/alarmCenter/realtimeAlarm.vue"),
    meta: {
      title: "实时告警"
    }
  },
  {
    path: "vehicleWarning",
    name: "vehicleWarning",
    component: () =>
      import ("@/views/alarmCenter/alarmLog/vehicleWarning/vehicleWarning.vue"),
    meta: {
      title: "车辆告警"
    }
  },
  {
    path: "faceWarning",
    name: "faceWarning",
    component: () =>
      import ("@/views/alarmCenter/alarmLog/faceWarning/faceWarning.vue"),
    meta: {
      title: "人脸告警"
    }
  },
  {
    path: "generalAlarm",
    name: "generalAlarm",
    component: () =>
      import ("@/views/alarmCenter/alarmLog/generalAlarm/generalAlarm.vue"),
    meta: {
      title: "通用告警"
    }
  },
  {
    path: "alarmStatistics",
    name: "alarmStatistics",
    component: () =>
      import ("@/views/alarmCenter/alarmStatistics/index.vue"),
    meta: {
      title: "告警统计"
    }
  }
];